(() => {
  // app/scripts/common/component/cartNote.js
  var { debounceTime } = theme;
  var CartNote = class extends HTMLElement {
    constructor() {
      super();
      const input = this.querySelector("[name=note]");
      this.lastSavedNote = input?.value;
      const saveAfterInput = debounceTime(() => {
        this.noteInputPending = false;
        this.saveNote(input.value);
      }, 1e3);
      input?.addEventListener("input", () => {
        this.noteInputPending = true;
        const status = this.querySelector("[data-note-status]");
        if (status)
          status.textContent = "";
        saveAfterInput();
      });
      this.querySelector("[data-note-retry]")?.addEventListener("click", () => {
        this.noteInputPending = false;
        this.saveNote(input.value);
      });
    }
    async saveNote(value) {
      if (!this.isSaving && value === this.lastSavedNote)
        return;
      this.queuedNote = value;
      if (this.isSaving)
        return;
      this.isSaving = true;
      const error = this.querySelector("[data-note-error]");
      const status = this.querySelector("[data-note-status]");
      const input = this.querySelector("[name=note]");
      const retry = this.querySelector("[data-note-retry]");
      if (status)
        status.textContent = "";
      while (this.queuedNote !== undefined) {
        const note = this.queuedNote;
        this.queuedNote = undefined;
        try {
          if (note !== this.lastSavedNote) {
            const result = await window.fetch(`${theme.routes.cartUrl}/update.js`, {
              method: "POST",
              credentials: "same-origin",
              headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;" },
              body: JSON.stringify({ note })
            });
            const response = await result.json();
            if (!result.ok || response.status || String(response.note || "") !== note)
              throw new Error("Cart note was not saved");
            this.lastSavedNote = note;
          }
          if (error)
            error.hidden = true;
          input.removeAttribute("aria-describedby");
          if (retry) {
            if (document.activeElement === retry)
              input.focus();
            retry.hidden = true;
          }
          if (status && this.queuedNote === undefined && !this.noteInputPending && input.value === note)
            status.textContent = this.dataset.noteSaved || "";
        } catch (failure) {
          this.lastSavedNote = undefined;
          if (error) {
            error.hidden = false;
            input.setAttribute("aria-describedby", error.id);
          }
          if (retry)
            retry.hidden = false;
          if (status)
            status.textContent = "";
        }
      }
      this.isSaving = false;
    }
  };
  customElements.define("cart-note", CartNote);

  // app/scripts/common/component/cartRemove.js
  var CartRemoveButton = class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector("a");
      link.addEventListener("click", (event) => {
        try {
          event.preventDefault();
          let { key, sections, sections_url } = link.dataset;
          if (!key)
            return;
          sections = [sections];
          this.closest("cart-component,cart-drawer-component").dispatchEvent(new CustomEvent("change", {
            bubbles: true,
            detail: {
              customElement: {
                target: link,
                key,
                quantity: 0,
                sections,
                sections_url
              }
            }
          }));
        } catch (e) {
          console.log(e);
        }
      });
    }
  };
  customElements.define("cart-remove-button", CartRemoveButton);

  // app/scripts/common/component/cartUpdateComponent.js
  !customElements.get("cart-update-component") && customElements.define("cart-update-component", class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", (e) => {
        this.currentTarget = e.target;
        let { value } = this.currentTarget;
        if (this.currentTarget.type == "checkbox") {
          value = this.currentTarget.checked;
        }
        this.onUpdate(value);
        if (this.querySelector(".jsValue"))
          this.querySelector(".jsValue").innerHTML = this.currentTarget.dataset.value || value;
      });
    }
    onUpdate(value) {
      const attributes = { [this.dataset.type]: value };
      this.disabled = true;
      this.cartUpdate(attributes);
    }
    set disabled(value) {
      this.classList.toggle("event-none", value);
    }
    set setValue(element) {
      this.currentTarget = element;
      let { value } = element;
      if (element.type == "checkbox") {
        value = element.checked;
      }
      this.onUpdate(value);
      if (this.querySelector(".jsValue"))
        this.querySelector(".jsValue").innerHTML = element.dataset.value || value;
    }
    async onFinished() {
      this.updateState();
      this.disabled = false;
    }
    async updateState() {
      const { sectionId } = this.dataset;
      if (!sectionId)
        return;
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += sectionId;
      let html = await fetch(url);
      html = await html.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      this.closest("filter-component")?.render(div);
      if (this.currentTarget.closest("details[open]") && (this.currentTarget.closest("filter-component") && window.matchMedia("(max-width: 991px)").matches))
        return;
      if (this.currentTarget.closest("details[open]"))
        this.currentTarget.closest("details[open]").open = false;
    }
  });

  // app/scripts/cart-drawer-component.js
  var { debounceTime: debounceTime2 } = theme;
  var cartDrawerComponent = class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", this.onChange.bind(this));
    }
    set open(value) {
      const popup = this.closest("popup-component");
      if (value) {
        this.closeAllCurrentPopups();
        popup.open();
      } else
        popup.close();
    }
    set refresh(sections) {
      const div = document.createElement("div");
      div.innerHTML = sections[this.sectionName];
      const replacement = div.querySelector(this.tagName);
      if (replacement)
        this.renderCartContent(replacement);
    }
    closeAllCurrentPopups() {
      document.querySelectorAll("popup-component.active")?.forEach((popup) => {
        popup.close();
      });
    }
  };
  customElements.define("cart-drawer-component", cartDrawerComponent);
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".jsCartDrawer"))
      return;
    e.preventDefault();
    document.querySelector("cart-drawer-component").open = true;
  });
})();
